import { SubclaimsList } from "./SubclaimsList";
import { Box, Flex, Text } from "@chakra-ui/react";
import { t } from "i18next";

type SubclaimSectionProps = {
    activeClaimRef: string | undefined;
    activeSubClaimRef: string | undefined;
    showSubclaimList: boolean;
    updateSubClaim: (subClaimRef: string) => void;
    subClaimsRef?: string;
    crmId?: string;
};

export const SubclaimSection = ({
    activeClaimRef,
    activeSubClaimRef,
    showSubclaimList,
    updateSubClaim,
    subClaimsRef,
    crmId
}: SubclaimSectionProps) => {
    if (showSubclaimList) {
        return (
            <SubclaimsList
                claimRef={activeClaimRef || ""}
                defaultValue={activeSubClaimRef ?? ""}
                onChange={updateSubClaim}
                crmId={crmId}
            />
        );
    }
    return (
        <Box>
            <Text mb="0.5rem" display="block" asChild>
                <b>{t("invoices:createInvoice.generalInfo.subClaimNo")}</b>
            </Text>
            <Flex gap="0.5rem" align="center">
                <Text id="subClaimNo">{subClaimsRef ?? "—"}</Text>
            </Flex>
        </Box>
    );
};
